module.exports = __webpack_public_path__ + "img/form.382d3bb2.png";